enum BankSendTypeEnum {
    'SCREEN_DOWNLOAD' = 1,
    'VAN' = 2,
    'API' = 3,
}

export default BankSendTypeEnum;
